module.exports = __webpack_public_path__ + "templates.category_filter-0c2ef779.html";